import React from 'react';
import { Grid } from '@material-ui/core';
import KPICard from './KPICard';

const IconKpiRow = ({ cards, onSelect }) => (
  <Grid container spacing={2} style={{ marginBottom: 10 }}>
    {(cards || []).map(({ key, icon, label, value, sub, color, tab }) => (
      <Grid item xs={12} sm={6} md key={key}>
        <KPICard
          title={label}
          value={value}
          subtitle={sub}
          color={color}
          icon={icon}
          onClick={tab && onSelect ? () => onSelect(tab) : undefined}
        />
      </Grid>
    ))}
  </Grid>
);

export default IconKpiRow;
